function Todo() {
  const items = ["item1", "item2"];
  return (
    <div className="bg-gray-200 rounded-md shadow-md">
      <div className="font-semibold p-2">TODO:</div>
      <div className="flex flex-col gap-2 bg-gray-200 rounded-md shadow-md p-2">
        {items.map((item) => (
          <div className="p-2 rounded-md border">{item}</div>
        ))}
      </div>
    </div>
  );
}

export default Todo;
